import { Text } from "@chakra-ui/react";

const Loading: React.FC = () => {
    return (
        <Text>ロード中...</Text>
    );
};

export default Loading;
